/* Pluszkowo – bajkowa warstwa (fairy.js). Delikatny czarodziejski pył przy kliknięciach i ruchu kursora. */
(function () {
  'use strict';
  var html = document.documentElement;
  var level = html.getAttribute('data-fairy') || 'soft';

  /* uczciwa informacja o dostawie: data wysyłki + szacowany termin doręczenia (4–15 dni rob.) */
  var DAYS = ['w niedzielę', 'w poniedziałek', 'we wtorek', 'w środę', 'w czwartek', 'w piątek', 'w sobotę'];
  function addWorkdays(from, n) {
    var d = new Date(from.getTime()), k = 0;
    while (k < n) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) k++; }
    return d;
  }
  function ddmm(d) { return String(d.getDate()).padStart(2, '0') + '.' + String(d.getMonth() + 1).padStart(2, '0'); }
  function deliveryText() {
    var out = addWorkdays(new Date(), 2), from = addWorkdays(out, 4), to = addWorkdays(out, 15);
    return 'Wysyłka najpóźniej ' + DAYS[out.getDay()] + ' (' + ddmm(out) + '). Szacowana dostawa: ' + ddmm(from) + '–' + ddmm(to) + '.';
  }
  function fixDelivery() {
    document.querySelectorAll('[data-dispatch-text]').forEach(function (el) {
      var t = deliveryText();
      if (el.textContent !== t) el.textContent = t;
    });
    document.querySelectorAll('[data-stock-text]').forEach(function (el) {
      var t = el.textContent.trim(), re = /wysyłka\s+w\s+48\s*h$/;
      if (re.test(t)) el.textContent = t.replace(re, 'wysyłka w 48 h, dostawa 4–20 dni rob.');
    });
  }
  window.addEventListener('load', fixDelivery);
  document.querySelectorAll('[data-dispatch-text], [data-stock-text]').forEach(function (el) {
    if ('MutationObserver' in window) new MutationObserver(function () { fixDelivery(); }).observe(el, { childList: true, characterData: true, subtree: true });
  });
  fixDelivery();

  if (level === 'off') return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;

  var COLORS = ['#FFD86B', '#FF8FB1', '#C9B8FF', '#8FD3FF', '#FFFFFF'];
  var live = 0, MAX = level === 'more' ? 90 : 50;

  function particle(x, y, opts) {
    if (live >= MAX) return;
    var p = document.createElement('span');
    p.className = 'fdust' + (Math.random() < 0.35 ? ' fdust--dot' : '');
    var ang = (opts.angle != null ? opts.angle : Math.random() * Math.PI * 2);
    var dist = opts.dist * (0.55 + Math.random() * 0.6);
    p.style.setProperty('--sx', x + 'px');
    p.style.setProperty('--sy', y + 'px');
    p.style.setProperty('--dx', Math.cos(ang) * dist + 'px');
    p.style.setProperty('--dy', (Math.sin(ang) * dist + (opts.fall || 0)) + 'px');
    p.style.setProperty('--c', COLORS[(Math.random() * COLORS.length) | 0]);
    var s = opts.size * (0.6 + Math.random() * 0.7);
    p.style.width = p.style.height = s + 'px';
    p.style.animationDuration = (opts.dur || 900) + 'ms';
    document.body.appendChild(p);
    live++;
    p.addEventListener('animationend', function () { p.remove(); live--; }, { once: true });
  }

  function burst(x, y, n) {
    for (var i = 0; i < n; i++) {
      particle(x, y, { angle: (i / n) * Math.PI * 2 + Math.random() * .4, dist: 46, size: 11, fall: 10 });
    }
  }
  window.PluszkowoFairy = { burst: burst };

  /* iskierki przy kliknięciu przycisków i wyborów */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('.btn, .tiercard, .qb__opt, .spot__tab, .sizer__chip, [data-add-btn], .night-toggle');
    if (!t) return;
    var x = e.clientX, y = e.clientY;
    if (!x && !y) { var r = t.getBoundingClientRect(); x = r.left + r.width / 2; y = r.top + r.height / 2; }
    burst(x, y, t.matches('[data-add-btn], .btn--primary') ? 12 : 7);
  }, { passive: true });

  /* pył za kursorem: w hero (delikatnie) albo wszędzie (więcej magii) */
  var fine = window.matchMedia && window.matchMedia('(pointer: fine)').matches;
  if (fine) {
    var last = 0;
    var zone = level === 'more' ? document : document.querySelector('.hero');
    if (zone) {
      zone.addEventListener('pointermove', function (e) {
        var now = performance.now();
        if (now - last < (level === 'more' ? 45 : 70)) return;
        last = now;
        particle(e.clientX, e.clientY, { dist: 18, size: 8, fall: 26, dur: 800 });
      }, { passive: true });
    }
  }

  /* gwiezdny błysk, gdy otwiera się koszyk (np. po dodaniu piżamki) */
  var drawer = document.getElementById('CartDrawer');
  if (drawer && 'MutationObserver' in window) {
    var wasOpen = false;
    new MutationObserver(function () {
      var open = drawer.classList.contains('is-open');
      if (open && !wasOpen) {
        var panel = drawer.querySelector('.drawer__panel');
        var r = (panel || drawer).getBoundingClientRect();
        setTimeout(function () { burst(Math.max(r.left + 40, 40), 70, 12); }, 260);
      }
      wasOpen = open;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }
})();
